import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.7,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-226">
    {children}
  </motion.div>;
export const Section = ({
  children,
  className = '',
  id
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-20 px-6 ${className}`} data-id="element-227">
    <div className="max-w-[800px] mx-auto" data-id="element-228">{children}</div>
  </section>;
export const SectionLabel = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => <span className={`inline-block bg-cardBorder text-accent px-4 py-1 rounded-full text-[0.78rem] font-bold tracking-[2px] uppercase mb-4 ${className}`} data-id="element-229">
    {children}
  </span>;
export const Card = ({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) => <div className={`bg-white border border-cardBorder rounded-2xl shadow-card ${className}`} data-id="element-230">
    {children}
  </div>;
export const ButtonPrimary = ({
  text,
  href,
  className = ''
}: {
  text: string;
  href: string;
  className?: string;
}) => <a href={href} className={`inline-block bg-deepPurple text-white px-10 py-4 rounded-lg font-bold text-[1.05rem] no-underline transition-all duration-200 shadow-md hover:-translate-y-[2px] hover:shadow-lg ${className}`} data-id="element-231">
    {text}
  </a>;
export const ButtonSecondary = ({
  text,
  href,
  className = ''
}: {
  text: string;
  href: string;
  className?: string;
}) => <a href={href} className={`inline-block bg-deepPurple text-white px-10 py-4 rounded-lg font-bold text-[1.05rem] no-underline transition-all duration-200 shadow-md hover:-translate-y-[2px] hover:shadow-lg ${className}`} data-id="element-232">
    {text}
  </a>;